import cn from 'classnames';

import styles from './VideoPlayButton.module.scss';

type Props = {
  onClick?: () => void;
  href?: string;
  className?: string;
  ariaLabel?: string;
};

export const VideoPlayButton = ({ onClick, href, className, ariaLabel = 'Play video' }: Props) => {
  if (href) {
    return (
      <a href={href} className={cn(styles.wrapper, className)} aria-label={ariaLabel}>
        <span className={styles.blur} />
        <span className={styles.btn}>▶</span>
      </a>
    );
  }

  return (
    <button type="button" className={cn(styles.wrapper, className)} onClick={onClick} aria-label={ariaLabel}>
      <span className={styles.blur} />
      <span className={styles.btn}>▶</span>
    </button>
  );
};
